import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64ce84f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-search" }
const _hoisted_2 = { class: "dropdown" }
const _hoisted_3 = { class: "dropdown-menu dropdown-menu-start" }

import { ref, watchEffect } from 'vue'
import { Dropdown } from 'bootstrap'
import { useLivePersonSearch } from '@/rd/LivePersonSearch'
import PersonLink from '@/manage/PersonLink.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteSearch',
  setup(__props) {

const searchInputRef = ref<HTMLInputElement>()
const { searchTextRef, searchResultsRef } = useLivePersonSearch()

watchEffect(() => {
  var text = searchTextRef.value // access before 'if' so watch will notice
  if (searchInputRef.value) {
    const dd = new Dropdown(searchInputRef.value)
    if (text.length > 2) {
      dd.show()
    }
    else {
      dd.hide()
    }
  }
})

function searchResultSelected() {
  searchTextRef.value = ''
  searchResultsRef.value = []  
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "search",
        ref_key: "searchInputRef",
        ref: searchInputRef,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchTextRef) ? (searchTextRef).value = $event : null)),
        placeholder: "Search for people",
        "aria-label": "Search"
      }, null, 512), [
        [_vModelText, _unref(searchTextRef)]
      ]),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchResultsRef), (r) => {
          return (_openBlock(), _createElementBlock("li", {
            key: r.id,
            class: "dropdown-item"
          }, [
            _createVNode(PersonLink, {
              personId: r.id,
              class: "link-dark",
              onClick: searchResultSelected
            }, null, 8, ["personId"])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})